import Application from './Application';
import AwardRecommendation from './AwardRecommendation';
import Closeout from './Closeout';
import GrantSummary from './GrantSummary';
import Attachment from './Attachment';
import Comments from './Comments';

export {Closeout, GrantSummary, Attachment, Application, Comments};

export default {
  Application: Application,
  AwardRecommendation: AwardRecommendation,
  Closeout: Closeout,
  GrantSummary: GrantSummary,
  Attachment: Attachment,
  Comments: Comments,
};
